import { IPaginationResponse } from '../../../common';
import { IVehicleLookupsResponse, IVehicleResponse } from '../dtos';

const lookups: IVehicleLookupsResponse = {
  vehicleType: [
    {
      englishName: 'Car',
      arabicName: 'سيارة',
      id: 'Car'
    },
    {
      englishName: 'MotorByke',
      arabicName: 'موتوسيكل',
      id: 'Assigned'
    }
  ],
  // accessStatus: [
  //   {
  //     englishName: 'Normal',
  //     arabicName: 'عادي',
  //     id: 'New'
  //   },
  //   {
  //     englishName: 'ًWhite Listed',
  //     arabicName: 'قائمة بيضاء',
  //     id: 'InProgress'
  //   },
  //   {
  //     englishName: 'Black Listed',
  //     arabicName: 'قائمة سوداء',
  //     id: 'Closed'
  //   }
  // ]
};

const vehicleResponse: IVehicleResponse = {
  owner: {
    englishName: 'Ayman Mohamed',
    id: '817c1f41-f903-4d0c-a01f-cd201c7257b9',
    autoIncrementalId: 1
  },
  make: {
    englishName: 'make',
    id: '4541c310-6628-4b37-a605-70e9843d891d',
    autoIncrementalId: 1
  },
  model: {
    englishName: 'Swift 20',
    id: '354d3bfc-ae82-48df-ab10-aa4742b97a32',
    autoIncrementalId: 1
  },
  productionYear: 0,
  // accessStatus: 'Whitelisted',
  vehicleType: 'Car',
  image: 'assets/images/icons/car-icon.svg',
  color: 'black',
  licensePlate: {
    plateLetters: 'abc',
    plateDigits: '5216',
    country: {
      englishName: '',
      id: '78f0d6f9-c674-4c8e-b03f-ea9660574aa2',
      autoIncrementalId: 0
    },
    plateLicenseType: {
      englishName: 'Private3',
      id: '1ce7178f-0071-4aaa-bbe7-bb05ca56863c',
      autoIncrementalId: 1
    }
  },
  createdOnUtc: '2025-08-01T16:22:39.2688222',
  modifiedOnUtc: '2025-08-01T16:22:39.2693436',
  createdById: 'f48ea831-6c3c-45ab-8844-929a18f43c84',
  modifiedById: 'f48ea831-6c3c-45ab-8844-929a18f43c84',
  id: '40a78479-1a56-4ed3-9019-6459f7dffe00',
  autoIncrementalId: 1
};

const vehiclesResponse: IPaginationResponse<IVehicleResponse> = {
  items: [vehicleResponse, vehicleResponse, vehicleResponse],
  paginationMetadata: {
    totalItemCount: 3,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

export const vehiclesData = {
  vehiclesResponse,
  vehicleResponse,
  lookups
};
